import React from 'react';
import Popover from 'react-simple-popover';
import PropTypes from 'prop-types';

export default class SmartPopover extends React.Component {
  static propTypes = {
    placement: PropTypes.string,
    node: PropTypes.any,
    visible: PropTypes.bool,
    message: PropTypes.string
  };

  constructor(props) {
    super(props);
  }

  render() {
    const { placement, node, visible, message } = this.props;

    return (
      <Popover
        placement={placement}
        style={{ padding: '0px', width: 'fit-content', boxShadow: 'none', backgroundColor: '#ffffff00' }}
        target={node}
        show={visible}
      >
        <div>
          <div className="simple-popover">
            <div className={`popover-shape primary-border-color`}>
              <div className="popover-text">{message}</div>
            </div>
          </div>
        </div>
      </Popover>
    );
  }
}
